var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("div", { staticClass: "search-info" }, [
        _c("div", { staticClass: "search-results" }, [
          _c("p", { staticClass: "primary" }, [
            _vm._v("Search results for "),
            _c("strong", [_vm._v("“" + _vm._s(_vm.searchQuery) + "”")])
          ]),
          _vm._v(" "),
          _vm.numEvents === 1
            ? _c("p", { staticClass: "secondary" }, [
                _vm._v(_vm._s(_vm.numEvents) + " event matched your search")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.numEvents > 1
            ? _c("p", { staticClass: "secondary" }, [
                _vm._v(_vm._s(_vm.numEvents) + " events match your search")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.suggestions.length
            ? _c("div", { staticClass: "suggestions-header" }, [
                _c(
                  "p",
                  [
                    _vm._v(
                      "\n                    Did you mean:\n                    "
                    ),
                    _vm._l(_vm.suggestions, function(suggestion, index) {
                      return _c(
                        "span",
                        { key: suggestion.id },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: _vm.makeEntityRoute(
                                  suggestion.type,
                                  suggestion
                                )
                              }
                            },
                            [_vm._v(_vm._s(suggestion.name))]
                          ),
                          index !== _vm.suggestions.length - 1
                            ? [_vm._v(", ")]
                            : _vm._e()
                        ],
                        2
                      )
                    })
                  ],
                  2
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "date-filter" },
          [
            _c("span", { staticClass: "icon-calendar-blank" }),
            _vm._v(" "),
            _c(
              "fx-date-range",
              {
                attrs: {
                  align: "right",
                  "data-e2e": "search.date-filter",
                  "min-date": "today",
                  "custom-option-copy": "Choose Date",
                  "default-option-copy": "Any Date",
                  presets: _vm.dateRangeFilterPresets
                },
                on: { input: _vm.onDateRangeSelected },
                model: {
                  value: _vm.dateRange,
                  callback: function($$v) {
                    _vm.dateRange = $$v
                  },
                  expression: "dateRange"
                }
              },
              [
                _c("span", {
                  staticClass: "icon-chevron-lg-down",
                  attrs: { slot: "caret" },
                  slot: "caret"
                })
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("EventList", {
        attrs: {
          events: _vm.events,
          "format-points": _vm.formatPoints,
          "is-loading-events": _vm.isLoadingEvents,
          "is-loading-more-events": _vm.isLoadingMoreEvents,
          "is-loyalty-pricing": _vm.$store.state.isRedeemingLoyaltyPoints,
          "load-more-copy": "Show More",
          "loading-more-copy": "Loading More Events...",
          "make-event-route": _vm.makeEventRoute,
          pagination: _vm.pagination
        },
        on: { "load-more-events": _vm.loadMoreEvents }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }